const cardItems = [
  {
    title: '剑与魔法录',
    category: '热血冒险',
    tags: ['连载中', '人气'],
    image: 'https://readdy.ai/api/search-image?query=Manga%20cover%20style%20illustration%20of%20a%20warrior%20with%20sword%20in%20epic%20fantasy%20setting%2C%20dramatic%20lighting%2C%20warm%20orange%20and%20gold%20tones%2C%20action%20pose%2C%20anime%20art%20style%2C%20professional%20illustration%2C%20clean%20composition%20on%20simple%20background&width=600&height=800&seq=manga-card-01&orientation=portrait',
  },
  {
    title: '甜蜜陷阱',
    category: '恋爱甜宠',
    tags: ['完结', '高分'],
    image: 'https://readdy.ai/api/search-image?query=Romantic%20manga%20cover%20illustration%20of%20a%20couple%20in%20school%20uniform%2C%20soft%20pink%20and%20pastel%20tones%2C%20gentle%20spring%20atmosphere%2C%20anime%20art%20style%2C%20dreamy%20bokeh%20background%2C%20sweet%20and%20heartwarming%20vibe%2C%20clean%20composition&width=600&height=800&seq=manga-card-02&orientation=portrait',
  },
  {
    title: '暗夜侦探',
    category: '悬疑推理',
    tags: ['连载中', '新番'],
    image: 'https://readdy.ai/api/search-image?query=Mystery%20manga%20cover%20illustration%20with%20detective%20character%20in%20dark%20alley%2C%20noir%20atmosphere%2C%20cool%20blue%20and%20dark%20tones%2C%20dramatic%20shadows%2C%20anime%20art%20style%2C%20suspenseful%20mood%2C%20professional%20illustration%20with%20mysterious%20lighting&width=600&height=800&seq=manga-card-03&orientation=portrait',
  },
  {
    title: '异界召唤师',
    category: '奇幻异世界',
    tags: ['连载中', '推荐'],
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20manga%20cover%20with%20magical%20summoner%20character%2C%20glowing%20magic%20circle%2C%20mystical%20atmosphere%2C%20violet%20and%20gold%20tones%2C%20anime%20art%20style%2C%20ethereal%20lighting%2C%20otherworldly%20fantasy%20scene%2C%20clean%20composition&width=600&height=800&seq=manga-card-04&orientation=portrait',
  },
  {
    title: '都市夜话',
    category: '都市生活',
    tags: ['连载中', '热门'],
    image: 'https://readdy.ai/api/search-image?query=Modern%20slice%20of%20life%20manga%20cover%2C%20young%20professional%20in%20city%20at%20night%2C%20warm%20neon%20lighting%2C%20urban%20atmosphere%2C%20anime%20art%20style%2C%20relaxed%20and%20stylish%20vibe%2C%20clean%20composition%20with%20cityscape%20background&width=600&height=800&seq=manga-card-05&orientation=portrait',
  },
  {
    title: '仙途问道',
    category: '古风仙侠',
    tags: ['连载中', '国漫'],
    image: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20manhua%20cover%20style%2C%20immortal%20warrior%20in%20flowing%20robes%20on%20mountain%20peak%2C%20ink%20wash%20painting%20aesthetic%2C%20soft%20green%20and%20gold%20tones%2C%20traditional%20Chinese%20art%20influence%2C%20ethereal%20clouds%20and%20mist%2C%20elegant%20composition&width=600&height=800&seq=manga-card-06&orientation=portrait',
  },
  {
    title: '机甲纪元',
    category: '科幻未来',
    tags: ['连载中', '独家'],
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20mecha%20manga%20cover%2C%20giant%20robot%20in%20futuristic%20city%2C%20cool%20silver%20and%20cyan%20tones%2C%20cyberpunk%20atmosphere%2C%20anime%20art%20style%2C%20dynamic%20action%20pose%2C%20professional%20illustration%20with%20glowing%20effects&width=600&height=800&seq=manga-card-07&orientation=portrait',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50 scroll-mt-header">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-12">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">精品推荐</h2>
            <p className="text-foreground-500 text-sm md:text-base">编辑精选必读漫画，品质保证</p>
          </div>
          <a
            href="#ranking"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {cardItems.map((item, idx) => (
            <div
              key={item.title}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden bg-background-200 mb-3">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2 flex flex-wrap gap-1.5">
                  {item.tags.map((tag) => (
                    <span
                      key={tag}
                      className={`px-2 py-0.5 rounded-md text-[10px] font-medium ${
                        tag === '连载中' || tag === '新番'
                          ? 'bg-accent-500 text-background-50'
                          : tag === '完结' || tag === '高分'
                          ? 'bg-primary-500 text-background-50'
                          : 'bg-background-50/90 text-foreground-700'
                      }`}
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                {idx === 0 && (
                  <div className="absolute top-2 right-2 w-7 h-7 rounded-lg bg-accent-500 flex items-center justify-center">
                    <i className="ri-fire-line text-background-50 text-sm"></i>
                  </div>
                )}
              </div>
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">{item.title}</h3>
              <p className="text-xs text-foreground-500 mt-1">{item.category}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}